import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram, Facebook, ShieldCheck } from "lucide-react";

const INSTITUCIONAL = ["Sobre nós", "Política de Privacidade", "Trocas e Devoluções", "Fale Conosco"];
const AJUDA = ["Como comprar", "Formas de pagamento", "Entrega e Prazos", "Perguntas frequentes"];

export function Footer() {
  return (
    <footer className="bg-forest-deep text-alabaster" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1280px] gap-10 px-4 py-14 sm:px-6 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-clay/20 text-lg">🌱</span>
            <span className="flex flex-col leading-none">
              <span className="font-serif text-xl font-semibold">Multinativa</span>
              <span className="font-sans text-[9px] uppercase tracking-[0.25em] text-ochre">Saúde Natural</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs font-sans text-sm text-alabaster/60">Loja de alimentos naturais e a granel para mais saúde e equilíbrio no seu dia a dia.</p>
          <div className="mt-5 flex gap-3">
            <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-forest-border text-alabaster hover:bg-clay"><Instagram size={16} /></a>
            <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-forest-border text-alabaster hover:bg-clay"><Facebook size={16} /></a>
            <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-forest-border text-alabaster hover:bg-clay"><Phone size={16} /></a>
          </div>
        </div>

        <div>
          <h4 className="font-sans text-sm font-semibold uppercase tracking-wide text-ochre">Institucional</h4>
          <ul className="mt-4 space-y-2 font-sans text-sm text-alabaster/70">
            {INSTITUCIONAL.map((l) => <li key={l}><Link to="/loja" className="hover:text-ochre">{l}</Link></li>)}
          </ul>
        </div>

        <div>
          <h4 className="font-sans text-sm font-semibold uppercase tracking-wide text-ochre">Ajuda</h4>
          <ul className="mt-4 space-y-2 font-sans text-sm text-alabaster/70">
            {AJUDA.map((l) => <li key={l}><Link to="/loja" className="hover:text-ochre">{l}</Link></li>)}
          </ul>
        </div>

        <div>
          <h4 className="font-sans text-sm font-semibold uppercase tracking-wide text-ochre">Atendimento</h4>
          <ul className="mt-4 space-y-3 font-sans text-sm text-alabaster/70">
            <li className="flex items-center gap-2"><Phone size={15} className="text-ochre" /> (19) 99999-9999</li>
            <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 text-ochre" /> Rua 15 de novembro, 1504 · Centro · Indaiatuba/SP</li>
          </ul>
          <div className="mt-4 flex flex-wrap gap-2">
            {["Visa", "Master", "Elo", "Pix", "Boleto"].map((p) => (
              <span key={p} className="rounded-md border border-forest-border bg-forest-surface px-2.5 py-1 font-sans text-[11px] font-medium text-alabaster/80">{p}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-forest-border">
        <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-2 px-4 py-4 sm:flex-row sm:px-6">
          <p className="font-sans text-xs text-alabaster/60">© {new Date().getFullYear()} Multinativa Saúde Natural. Todos os direitos reservados.</p>
          <p className="flex items-center gap-1.5 font-sans text-xs text-alabaster/60"><ShieldCheck size={14} className="text-ochre" /> Ambiente 100% seguro</p>
        </div>
      </div>
    </footer>
  );
}
